/**
 * @deprecated HtmlUtil is not recommended in Vue, use Vue native supports for HTML and DOM instead
 */
class HtmlUtil {
  /**
   * @description Highlights keywords in a string by wrapping them in mark tags
   * @param {string} string - The string to search in
   * @param {string} keyword - The keyword to highlight
   * @return {string} - The string with highlighted keywords
   */
  highlightKeyword(string: string, keyword: string): string {
    const keycode = ['*', '+', '\\'];
    if (keyword === '' || keyword === null || keyword === undefined) {
      return string;
    }

    // Escape special characters in the keyword
    const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    if (string != null) {
      string = new DOMParser().parseFromString(string, 'text/html').body.textContent || '';
    }

    if (keycode.findIndex(k => k === keyword) === -1 && string != null && string !== '') {
      return string.replace(new RegExp('(' + escapedKeyword + ')', 'ig'), '<mark class="text__highlight">$1</mark>');
    }
    return string;
  }

  /**
   * @description decodes HTML entities in a string
   * @param  {string} string - string to decode
   * @return  {string} - decoded string
   */
  decodeEntity(string: string): string {
    return string
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&apos;/g, "'")
      .replace(/&frasl;/g, '/');
  }

  /**
   * @description encodes special characters to HTML entities
   * @param  {string} string - string to encode
   * @return  {string} - encoded string
   */
  encodeEntity(string: string): string {
    return string
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;')
      .replace(/\//g, '&frasl;');
  }

  /**
   * @description strip HTML from string
   * @param  {string} string - string to strip
   * @return  {string} - stripped string
   */
  stripHTML(string: string): string {
    const div = document.createElement('div');
    div.innerHTML = string;
    return div.textContent || div.innerText || '';
  }
}

export const htmlUtil = new HtmlUtil();
